var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-view-chip',{attrs:{"value":_vm.value,"options":_vm.model.options,"hideText":_vm.model.hideText,"showText":_vm.values.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }